import * as React from 'react';
import { observable } from "mobx";
import { observer } from "mobx-react";
import { resolve } from "inversify-react";
import autobind from "autobind-decorator";

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from "src/core/services/ui/dialog.service";
import { AirlineListView } from "./airline-list.view";
import { AirlineListDataService } from "./airline-list.data";

@observer
export class AirlineListController extends React.Component<ControllerProps<any>, any> {
    @observable
    protected dataService: AirlineListDataService;

    @resolve
    protected dialogService: DialogService;

    @resolve
    protected toast: ToastNotifications;

    public constructor(props) {
        super(props);
        this.dataService = AirlineListDataService.make();
    }

    public componentDidMount() {
        this.loadData();
    }

    @autobind
    protected onItemDoubleClicked(item: AirlineSummary) {
        this.props.history.push(`/general/airlines/${item == null ? 'new' : item.id}`);
    }

    @autobind
    protected loadData() {
        this.props.setBusy(true);
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.addFilter('isDeleted', 'eq', false);
        this.dataService.load(query => query)
            .then(() => this.props.setBusy(false))
            .catch(error => {
                this.props.setBusy(false)
                //  this.dialogService.show("Error", error.toString());
                this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
            });
    }

    public render() {
        return <AirlineListView
            model={this.dataService}
            setBusy={this.props.setBusy}
            onItemDoubleClicked={this.onItemDoubleClicked}
            {...this.props } />
    }
}



// WEBPACK FOOTER //
// ./src/app/general/airlines/list/airline-list.controller.tsx